package diana.soleil.design.iraniancanadienbazzar.feature.profile

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.platform.LocalUriHandler
import kotlinx.coroutines.launch
import diana.soleil.design.iraniancanadienbazzar.core.model.SubscriptionPlan
import diana.soleil.design.iraniancanadienbazzar.core.model.BillingInterval
import diana.soleil.design.iraniancanadienbazzar.core.model.formatPriceCents
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppBottomSheet
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppChip
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButtonVariant
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIconButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppCard
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIcon
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppTextField
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.BusinessCover
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppearanceSwitcher
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.LanguageSwitcher
import diana.soleil.design.iraniancanadienbazzar.core.model.AppearanceMode
import diana.soleil.design.iraniancanadienbazzar.core.model.Language
import diana.soleil.design.iraniancanadienbazzar.core.model.categoryIconKey
import diana.soleil.design.iraniancanadienbazzar.core.model.memberSinceMonthYear
import diana.soleil.design.iraniancanadienbazzar.core.model.cityLabel
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.BusinessListItem
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ProfileAbout
import diana.soleil.design.iraniancanadienbazzar.core.data.MAX_PROFILE_PHOTOS
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ProfilePhotoStrip
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ProfileDetail
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.SectionHeader
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.SettingsRow
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.SettingsToggleRow
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.categoryImageRes
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.appContentWidth
import diana.soleil.design.iraniancanadienbazzar.core.devmenu.DeveloperMenuContent
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.Res
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.lang_english
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.lang_french
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.lang_persian
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_badge_new
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_about_empty
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_about_title
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_photo_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_photo_remove
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_photo_add
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_photos_title
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_pro_badge
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_tickets_sub
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_tickets
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_orders_sub
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_orders
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_open_settings_sub
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_open_settings
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_section_your_stuff
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_detail_speaks
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_detail_hometown
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_about_interests
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_about_details
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_avatar_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_dev_menu_title
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_edit
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_edit_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_edit_bio_label
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_edit_bio_placeholder
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_edit_name_label
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_edit_name_placeholder
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_edit_save
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_edit_save_failed
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_photo_upload_failed
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_edit_photo
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_edit_occupation_label
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_edit_occupation_placeholder
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_edit_hometown_label
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_edit_city_label
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_edit_city_placeholder
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_edit_hometown_placeholder
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_edit_relationship_label
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_relationship_single
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_relationship_in_relationship
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_relationship_married
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_edit_languages_label
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_lang_fa
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_lang_en
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_lang_fr
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_edit_interests_label
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_edit_interests_placeholder
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_edit_interests_add_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_member_since
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_months
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_role_community
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_section_following
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_section_saved
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_saved_row_sub
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_saved_row
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_section_settings
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_appearance
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.appearance_system
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.appearance_light
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.appearance_dark
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_pro_title
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_pro_blurb
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_pro_active
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_pro_monthly
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_pro_plan_row
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_pro_annual
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_pro_manage
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_pro_failed
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_unsave_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_account
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_account_sub
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_language
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_dashboard
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_dashboard_sub
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_messages
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_messages_sub
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_invite
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_invite_sub
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_invite_message
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_language_sub
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_orders
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_tickets
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_tickets_sub
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_orders_sub
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_email_updates
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_email_updates_sub
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_notifications
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_save_failed
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_notifications_sub
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_admin
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_admin_sub
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_moderation
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_tour
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_tour_sub
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_moderation_sub
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_blocked_users
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_blocked_users_sub
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_interests
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_interests_sub
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_analytics
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_analytics_sub
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_legal
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_legal_sub
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_privacy
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_privacy_sub
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_delete_account
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_delete_account_sub
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_sign_out
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_stat_reviews
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_stat_following
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_stat_saved
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_version
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_guest_hint
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_guest_name
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_saved_empty
import org.jetbrains.compose.resources.stringArrayResource
import org.jetbrains.compose.resources.stringResource
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import diana.soleil.design.iraniancanadienbazzar.core.common.AppPreferences
import org.koin.compose.koinInject
import org.koin.compose.viewmodel.koinViewModel

/**
 * Profile & Settings — Stitch `b970cd0f` (Directory & Community System). Tokens + string resources.
 * Mock profile pending Auth/Firestore. The build-number footer reveals a debug Developer Menu after
 * 5 taps (see docs/DEVELOPER_MENU.md); full tooling moves to :core:devmenu with real build detection.
 */
@Composable
fun ProfileScreen(
    modifier: Modifier = Modifier,
    userName: String? = null,
    userEmail: String? = null,
    isGuest: Boolean = true,
    onBusinessClick: (String) -> Unit = {},
    dashboardEnabled: Boolean = false,
    onOpenDashboard: () -> Unit = {},
    ordersEnabled: Boolean = false,
    onOpenOrders: () -> Unit = {},
    ticketsEnabled: Boolean = false,
    onOpenTickets: () -> Unit = {},
    /** Opens the pushed Settings screen — every preference lives there now. */
    onOpenSettings: () -> Unit = {},
    onOpenSaved: () -> Unit = {},
) {
    val viewModel: ProfileViewModel = koinViewModel()
    val data by viewModel.state.collectAsStateWithLifecycle()
    // The signed-in member's public card — carries the uploaded avatar for the header.
    val myCard by viewModel.myCard.collectAsStateWithLifecycle()
    val savedTotal by viewModel.savedTotal.collectAsStateWithLifecycle()
    // Analytics consent (Quebec Law 25 — off by default). Backed by AppPreferences; the gated tracker
    // reads it on every event, so flipping this takes effect immediately.
    val preferences = koinInject<AppPreferences>()
    // Invite/referral loop — the highest-leverage growth mechanic in a network-effect product.
    val shareService = koinInject<diana.soleil.design.iraniancanadienbazzar.core.common.ShareService>()
    val shareConfig = koinInject<diana.soleil.design.iraniancanadienbazzar.core.data.ShareConfig>()
    val inviteMessage = stringResource(Res.string.profile_invite_message, shareConfig.inviteLink())
    var showEditSheet by remember { mutableStateOf(false) }

    val effectiveName = data.displayName?.takeIf { it.isNotBlank() }
        ?: userName?.takeIf { it.isNotBlank() }
        ?: userEmail?.substringBefore('@')?.takeIf { it.isNotBlank() }
        ?: stringResource(Res.string.profile_guest_name)
    val months = stringArrayResource(Res.array.profile_months)
    val memberSince = memberSinceMonthYear(data.memberSinceMillis)?.let { (month, year) ->
        val label = months.getOrNull(month - 1)?.let { "$it $year" } ?: year.toString()
        stringResource(Res.string.profile_member_since, label)
    }

    LazyColumn(
        modifier = modifier
            .background(AppTheme.colors.background)
            .appContentWidth(AppTheme.sizes.contentMaxWidth)
            .fillMaxHeight()
            .statusBarsPadding(),
        contentPadding = PaddingValues(AppTheme.spacing.lg),
        verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.lg),
    ) {
        item {
            ProfileHeader(
                name = effectiveName,
                avatarId = myCard?.uid,
                photoUrl = myCard?.photoUrl,
                subtitle = when {
                    isGuest -> stringResource(Res.string.profile_guest_hint)
                    memberSince != null ->
                        stringResource(Res.string.profile_role_community) + " · " + memberSince
                    else -> userEmail.orEmpty()
                },
                reviewCount = data.myReviewCount,
                savedCount = savedTotal,
                onSavedClick = onOpenSaved,
                followingCount = data.followingBusinesses.size,
                proBadge = stringResource(Res.string.profile_pro_badge).takeIf { data.proActive },
                showEdit = !isGuest,
                onEdit = { showEditSheet = true },
            )
        }

        // The real profile body. Until 2026-08-02 this screen showed only the bio and threw the rest
        // away — `myCard` was already loaded and only `uid`/`photoUrl` were read, so people filled in
        // occupation/hometown/languages/interests in the editor and could never see them anywhere.
        if (!isGuest) {
            item {
                val card = myCard
                val details = buildList {
                    card?.occupation?.takeIf { it.isNotBlank() }?.let { add(ProfileDetail("work", it)) }
                    relationshipLabel(card?.relationship)?.let { add(ProfileDetail("favorite", it)) }
                    card?.hometown?.takeIf { it.isNotBlank() }?.let {
                        add(ProfileDetail("home", stringResource(Res.string.profile_detail_hometown, it)))
                    }
                    languagesLabel(card?.languages.orEmpty())?.let {
                        add(ProfileDetail("translate", stringResource(Res.string.profile_detail_speaks, it)))
                    }
                }
                AppCard(modifier = Modifier.fillMaxWidth()) {
                    Column(
                        modifier = Modifier
                            .clickable { showEditSheet = true }
                            .padding(AppTheme.spacing.lg),
                    ) {
                        ProfileAbout(
                            bio = data.bio,
                            details = details,
                            interests = card?.interests.orEmpty(),
                            aboutTitle = stringResource(Res.string.profile_about_title),
                            detailsTitle = stringResource(Res.string.profile_about_details),
                            interestsTitle = stringResource(Res.string.profile_about_interests),
                            emptyHint = stringResource(Res.string.profile_about_empty),
                        )
                    }
                }
            }

            // Public photo gallery. `PublicProfile.photos` has been in the model and the Firestore
            // rules (cap 6) since the People work, but it was only ever rendered on OTHER people's
            // profiles and there was no way to add one. Both ends wired 2026-08-03.
            item {
                val photos = myCard?.photos.orEmpty()
                if (photos.isNotEmpty()) {
                    Column(verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md)) {
                        SectionHeader(title = stringResource(Res.string.profile_photos_title))
                        ProfilePhotoStrip(
                            photos = photos,
                            photoContentDescription = stringResource(Res.string.profile_photo_a11y),
                        )
                    }
                }
            }
        }


        if (data.followingBusinesses.isNotEmpty()) {
            item { SectionHeader(title = stringResource(Res.string.profile_section_following)) }
            items(data.followingBusinesses.size) { index ->
                val followed = data.followingBusinesses[index]
                val lang = AppTheme.language
                val coverUrl = followed.coverUrl?.takeIf { it.isNotBlank() }
                val icon = categoryIconKey(followed.categoryId)
                val imageRes = categoryImageRes(followed.categoryId)
                BusinessListItem(
                    name = followed.displayName(lang),
                    category = followed.serviceLine(lang),
                    rating = followed.rating.toFloat(),
                    newLabel = stringResource(Res.string.profile_badge_new).takeIf { followed.reviewCount == 0 },
                    distance = AppTheme.language.cityLabel(followed.address.city),
                    onClick = { onBusinessClick(followed.id) },
                    coverIcon = icon,
                    coverImageRes = imageRes,
                    thumbnail = coverUrl?.let { url -> { BusinessCover(imageUrl = url, iconName = icon, placeholderImageRes = imageRes) } },
                )
            }
        }

        item { SectionHeader(title = stringResource(Res.string.profile_section_your_stuff)) }
        item {
            AppCard(modifier = Modifier.fillMaxWidth()) {
                Column {
                    // Replaces the inline saved-businesses list this screen used to render. That list
                    // could only ever show businesses, while RSVP'd events and saved news had nowhere
                    // to surface at all; the Saved screen covers all three (owner request 2026-08-03).
                    SettingsRow(
                        "bookmarks", stringResource(Res.string.profile_saved_row), onOpenSaved,
                        subtitle = stringResource(Res.string.profile_saved_row_sub),
                    )
                    if (ordersEnabled) {
                        SettingsRow(
                            "receipt_long", stringResource(Res.string.profile_orders), onOpenOrders,
                            subtitle = stringResource(Res.string.profile_orders_sub),
                        )
                    }
                    if (ticketsEnabled) {
                        SettingsRow(
                            "confirmation_number", stringResource(Res.string.profile_tickets), onOpenTickets,
                            subtitle = stringResource(Res.string.profile_tickets_sub),
                        )
                    }
                    if (dashboardEnabled) {
                        SettingsRow(
                            "storefront", stringResource(Res.string.profile_setting_dashboard), onOpenDashboard,
                            subtitle = stringResource(Res.string.profile_setting_dashboard_sub),
                        )
                    }
                }
            }
        }

        item {
            AppCard(modifier = Modifier.fillMaxWidth()) {
                Column {
                    SettingsRow(
                        "settings", stringResource(Res.string.profile_open_settings), onOpenSettings,
                        subtitle = stringResource(Res.string.profile_open_settings_sub),
                    )
                }
            }
        }

    }



    if (showEditSheet) {
        val card by viewModel.myCard.collectAsStateWithLifecycle()
        val photoSaving by viewModel.photoSaving.collectAsStateWithLifecycle()
        val photoUploadFailed by viewModel.photoUploadFailed.collectAsStateWithLifecycle()
        val profileSaved by viewModel.profileSaved.collectAsStateWithLifecycle()
        // Only close the editor once the save actually succeeded — a failed save keeps it open so the
        // user can retry instead of silently losing their edits.
        LaunchedEffect(profileSaved) {
            if (profileSaved) {
                showEditSheet = false
                viewModel.consumeProfileSaved()
            }
        }
        EditProfileSheet(
            // Prefill with the same fallback chain the header shows — an email-only account has
            // no displayName, and an EMPTY name field left Save permanently disabled (owner
            // device report 2026-07-24).
            initialName = data.displayName?.takeIf { it.isNotBlank() }
                ?: userName?.takeIf { it.isNotBlank() }
                ?: userEmail?.substringBefore('@').orEmpty(),
            initialBio = data.bio.orEmpty(),
            card = card,
            photoSaving = photoSaving,
            photoUploadFailed = photoUploadFailed,
            saving = data.isSaving,
            saveFailed = data.saveFailed,
            onChangePhoto = viewModel::changePhoto,
            onAddPhoto = viewModel::addPhoto,
            onRemovePhoto = viewModel::removePhoto,
            onDismiss = { showEditSheet = false },
            onSave = { name, bio, city, occupation, hometown, relationship, languages, socialInterests ->
                // Do NOT close here — the LaunchedEffect above closes only on a successful save.
                viewModel.saveProfile(name, bio, city, occupation, hometown, relationship, languages, socialInterests)
            },
        )
    }
}

@Composable
private fun ProfileHeader(
    name: String,
    subtitle: String,
    reviewCount: Int,
    savedCount: Int,
    onSavedClick: (() -> Unit)? = null,
    followingCount: Int,
    showEdit: Boolean,
    onEdit: () -> Unit,
    photoUrl: String? = null,
    // Stable per-identity key for the initials-avatar colour (uid) — falls back to name for guests.
    avatarId: String? = null,
    /**
     * Pro STATUS as a compact badge (null = not Pro). The Mahaleh Pro controls live in Settings
     * (owner 2026-08-03); the profile only advertises the status.
     */
    proBadge: String? = null,
) {
    Column(
        modifier = Modifier.fillMaxWidth(),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
    ) {
        // Show the uploaded avatar when present; fall back to initials/person via PersonAvatar
        // (was hard-coded to a generic person glyph, so uploads never surfaced on the header).
        diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.PersonAvatar(
            name = name,
            id = avatarId ?: name,
            photoUrl = photoUrl,
            size = AppTheme.sizes.iconHero,
            contentDescription = stringResource(Res.string.profile_avatar_a11y),
        )
        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs),
        ) {
            Text(text = name, style = AppTheme.typography.headlineLg, color = AppTheme.colors.onSurface)
            if (proBadge != null) {
                Text(
                    text = proBadge,
                    style = AppTheme.typography.labelSm,
                    color = AppTheme.colors.onSecondaryContainer,
                    modifier = Modifier
                        .background(AppTheme.colors.secondaryContainer, AppTheme.shapes.pill)
                        .padding(horizontal = AppTheme.spacing.sm, vertical = AppTheme.spacing.xxs),
                )
            }
            if (showEdit) {
                Box(
                    modifier = Modifier
                        .size(AppTheme.sizes.minTouchTarget)
                        .clickable(onClick = onEdit),
                    contentAlignment = Alignment.Center,
                ) {
                    AppIcon(
                        "edit",
                        size = AppTheme.sizes.iconSm,
                        tint = AppTheme.colors.primary,
                        contentDescription = stringResource(Res.string.profile_edit_a11y),
                    )
                }
            }
        }
        if (subtitle.isNotBlank()) {
            Text(text = subtitle, style = AppTheme.typography.bodySm, color = AppTheme.colors.onSurfaceVariant)
        }
        Row(
            modifier = Modifier.fillMaxWidth().padding(top = AppTheme.spacing.sm),
            horizontalArrangement = Arrangement.SpaceEvenly,
        ) {
            Stat(followingCount, stringResource(Res.string.profile_stat_following))
            Stat(savedCount, stringResource(Res.string.profile_stat_saved), onClick = onSavedClick)
            Stat(reviewCount, stringResource(Res.string.profile_stat_reviews))
        }
    }
}

/** Stitch "About" card: shows the user's bio, or an add-a-bio prompt. Tapping opens the edit sheet. */
@Composable
private fun AboutCard(bio: String?, onClick: () -> Unit) {
    AppCard(modifier = Modifier.fillMaxWidth().clickable(onClick = onClick)) {
        Column(
            modifier = Modifier.padding(AppTheme.spacing.lg),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs),
        ) {
            Text(
                text = stringResource(Res.string.profile_about_title),
                style = AppTheme.typography.labelMd,
                color = AppTheme.colors.onSurfaceVariant,
            )
            val trimmedBio = bio?.trim().orEmpty()
            val hasBio = trimmedBio.isNotEmpty()
            Text(
                text = if (hasBio) trimmedBio else stringResource(Res.string.profile_about_empty),
                style = AppTheme.typography.bodyMd,
                color = if (hasBio) AppTheme.colors.onSurface else AppTheme.colors.onSurfaceVariant,
            )
        }
    }
}

/** Bottom sheet to edit display name + About/bio (Stitch "Edit Profile" modal). */
@Composable
private fun EditProfileSheet(
    initialName: String,
    initialBio: String,
    card: diana.soleil.design.iraniancanadienbazzar.core.model.PublicProfile?,
    photoSaving: Boolean,
    photoUploadFailed: Boolean,
    saving: Boolean,
    saveFailed: Boolean,
    onChangePhoto: () -> Unit,
    onAddPhoto: () -> Unit,
    onRemovePhoto: (String) -> Unit,
    onDismiss: () -> Unit,
    onSave: (
        name: String, bio: String, city: String?, occupation: String?, hometown: String?,
        relationship: String?, languages: List<String>, interests: List<String>,
    ) -> Unit,
) {
    var name by remember { mutableStateOf(initialName) }
    var bio by remember { mutableStateOf(initialBio) }
    // Where they live now — shown on their profile / people card. Was never editable (owner report
    // 2026-09-14: "everything in profile should be editable").
    var city by remember(card?.uid) { mutableStateOf(card?.city.orEmpty()) }
    var occupation by remember(card?.uid) { mutableStateOf(card?.occupation.orEmpty()) }
    var hometown by remember(card?.uid) { mutableStateOf(card?.hometown.orEmpty()) }
    var relationship by remember(card?.uid) { mutableStateOf(card?.relationship) }
    var languages by remember(card?.uid) { mutableStateOf(card?.languages ?: emptyList()) }
    var socialInterests by remember(card?.uid) { mutableStateOf(card?.interests ?: emptyList()) }
    var newInterest by remember { mutableStateOf("") }
    AppBottomSheet(
        onDismissRequest = onDismiss,
        title = stringResource(Res.string.profile_edit),
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .heightIn(max = AppTheme.sizes.editorSheetMaxHeight)
                .verticalScroll(rememberScrollState())
                .padding(horizontal = AppTheme.spacing.lg),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
        ) {
            // Photo — uploads immediately on pick so the avatar preview refreshes in place.
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
            ) {
                diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.PersonAvatar(
                    id = card?.uid ?: "me",
                    name = name.ifBlank { initialName.ifBlank { "?" } },
                    photoUrl = card?.photoUrl,
                    size = AppTheme.sizes.avatarLg,
                )
                AppButton(
                    text = stringResource(Res.string.profile_edit_photo),
                    onClick = onChangePhoto,
                    variant = AppButtonVariant.Secondary,
                    leadingIcon = "photo_camera",
                    enabled = !photoSaving,
                    loading = photoSaving,
                )
            }
            if (photoUploadFailed) {
                Text(
                    text = stringResource(Res.string.profile_photo_upload_failed),
                    style = AppTheme.typography.labelSm,
                    color = AppTheme.colors.error,
                )
            }
            // Public gallery (separate from the avatar). The "+" tile disappears at the cap so we
            // never let the user attempt a write the Firestore rule would reject.
            Text(
                text = stringResource(Res.string.profile_photos_title),
                style = AppTheme.typography.labelMd,
                color = AppTheme.colors.onSurfaceVariant,
            )
            val galleryPhotos = card?.photos.orEmpty()
            ProfilePhotoStrip(
                photos = galleryPhotos,
                photoContentDescription = stringResource(Res.string.profile_photo_a11y),
                addLabel = stringResource(Res.string.profile_photo_add)
                    .takeIf { galleryPhotos.size < MAX_PROFILE_PHOTOS },
                onAdd = onAddPhoto.takeIf { galleryPhotos.size < MAX_PROFILE_PHOTOS },
                removeContentDescription = stringResource(Res.string.profile_photo_remove),
                onRemove = onRemovePhoto,
            )
            AppTextField(
                value = name,
                onValueChange = { name = it },
                label = stringResource(Res.string.profile_edit_name_label),
                placeholder = stringResource(Res.string.profile_edit_name_placeholder),
                singleLine = true,
            )
            AppTextField(
                value = bio,
                onValueChange = { bio = it },
                label = stringResource(Res.string.profile_edit_bio_label),
                placeholder = stringResource(Res.string.profile_edit_bio_placeholder),
                singleLine = false,
            )
            AppTextField(
                value = city,
                onValueChange = { if (it.length <= 60) city = it },
                label = stringResource(Res.string.profile_edit_city_label),
                placeholder = stringResource(Res.string.profile_edit_city_placeholder),
                singleLine = true,
            )
            AppTextField(
                value = occupation,
                onValueChange = { if (it.length <= 80) occupation = it },
                label = stringResource(Res.string.profile_edit_occupation_label),
                placeholder = stringResource(Res.string.profile_edit_occupation_placeholder),
                singleLine = true,
            )
            AppTextField(
                value = hometown,
                onValueChange = { if (it.length <= 60) hometown = it },
                label = stringResource(Res.string.profile_edit_hometown_label),
                placeholder = stringResource(Res.string.profile_edit_hometown_placeholder),
                singleLine = true,
            )
            Text(
                text = stringResource(Res.string.profile_edit_relationship_label),
                style = AppTheme.typography.labelMd,
                color = AppTheme.colors.onSurfaceVariant,
            )
            androidx.compose.foundation.layout.FlowRow(
                horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
                verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
            ) {
                diana.soleil.design.iraniancanadienbazzar.core.model.RelationshipStatus.entries.forEach { option ->
                    AppChip(
                        label = stringResource(
                            when (option) {
                                diana.soleil.design.iraniancanadienbazzar.core.model.RelationshipStatus.Single ->
                                    Res.string.profile_relationship_single
                                diana.soleil.design.iraniancanadienbazzar.core.model.RelationshipStatus.InRelationship ->
                                    Res.string.profile_relationship_in_relationship
                                diana.soleil.design.iraniancanadienbazzar.core.model.RelationshipStatus.Married ->
                                    Res.string.profile_relationship_married
                            },
                        ),
                        selected = relationship == option.wire,
                        // Tapping the selected chip clears it — status stays optional (privacy).
                        onClick = { relationship = if (relationship == option.wire) null else option.wire },
                    )
                }
            }
            Text(
                text = stringResource(Res.string.profile_edit_languages_label),
                style = AppTheme.typography.labelMd,
                color = AppTheme.colors.onSurfaceVariant,
            )
            Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
                listOf(
                    "fa" to Res.string.profile_lang_fa,
                    "en" to Res.string.profile_lang_en,
                    "fr" to Res.string.profile_lang_fr,
                ).forEach { (code, labelRes) ->
                    AppChip(
                        label = stringResource(labelRes),
                        selected = code in languages,
                        onClick = {
                            languages = if (code in languages) languages - code else languages + code
                        },
                    )
                }
            }
            Text(
                text = stringResource(Res.string.profile_edit_interests_label),
                style = AppTheme.typography.labelMd,
                color = AppTheme.colors.onSurfaceVariant,
            )
            if (socialInterests.isNotEmpty()) {
                androidx.compose.foundation.layout.FlowRow(
                    horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
                    verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
                ) {
                    socialInterests.forEach { interest ->
                        AppChip(
                            label = interest,
                            selected = true,
                            leadingIcon = "close",
                            onClick = { socialInterests = socialInterests - interest },
                        )
                    }
                }
            }
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
            ) {
                AppTextField(
                    value = newInterest,
                    onValueChange = { if (it.length <= 30) newInterest = it },
                    placeholder = stringResource(Res.string.profile_edit_interests_placeholder),
                    singleLine = true,
                    modifier = Modifier.weight(1f),
                )
                AppIconButton(
                    iconName = "add",
                    contentDescription = stringResource(Res.string.profile_edit_interests_add_a11y),
                    onClick = {
                        val trimmed = newInterest.trim()
                        if (trimmed.isNotEmpty() && socialInterests.size < 10 && trimmed !in socialInterests) {
                            socialInterests = socialInterests + trimmed
                        }
                        newInterest = ""
                    },
                )
            }
            if (saveFailed) {
                Text(
                    text = stringResource(Res.string.profile_edit_save_failed),
                    style = AppTheme.typography.labelSm,
                    color = AppTheme.colors.error,
                )
            }
            AppButton(
                text = stringResource(Res.string.profile_edit_save),
                onClick = {
                    onSave(
                        name, bio,
                        city.trim().takeIf { it.isNotBlank() },
                        occupation.trim().takeIf { it.isNotBlank() },
                        hometown.trim().takeIf { it.isNotBlank() },
                        relationship,
                        languages,
                        socialInterests,
                    )
                },
                modifier = Modifier.fillMaxWidth(),
                enabled = name.isNotBlank() && !saving,
                loading = saving,
            )
        }
    }
}

/**
 * Mahaleh Pro upgrade / management card. Not subscribed → plan buttons that open Stripe Checkout;
 * subscribed → an active badge + "Manage subscription" (Stripe Billing Portal). URLs open via the
 * platform browser (hosted Stripe pages), so no card fields live in the app.
 */
@Composable
internal fun ProUpgradeCard(
    proActive: Boolean,
    onCheckout: suspend (planId: String) -> String?,
    onManage: suspend () -> String?,
) {
    val scope = rememberCoroutineScope()
    val uriHandler = LocalUriHandler.current
    var busy by remember { mutableStateOf(false) }
    var failed by remember { mutableStateOf(false) }
    AppCard(modifier = Modifier.fillMaxWidth()) {
        Column(
            modifier = Modifier.padding(AppTheme.spacing.lg),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
        ) {
            Text(
                text = stringResource(if (proActive) Res.string.profile_pro_active else Res.string.profile_pro_blurb),
                style = AppTheme.typography.bodyMd,
                color = AppTheme.colors.onSurfaceVariant,
            )
            if (failed) {
                Text(
                    text = stringResource(Res.string.profile_pro_failed),
                    style = AppTheme.typography.labelSm,
                    color = AppTheme.colors.error,
                )
            }
            if (proActive) {
                AppButton(
                    text = stringResource(Res.string.profile_pro_manage),
                    onClick = {
                        failed = false; busy = true
                        scope.launch {
                            val url = onManage()
                            busy = false
                            if (url != null) uriHandler.openUri(url) else failed = true
                        }
                    },
                    modifier = Modifier.fillMaxWidth(),
                    variant = AppButtonVariant.Secondary,
                    loading = busy,
                )
            } else {
                SubscriptionPlan.all.forEach { plan ->
                    val label = stringResource(
                        when (plan.interval) {
                            BillingInterval.Month -> Res.string.profile_pro_monthly
                            BillingInterval.Year -> Res.string.profile_pro_annual
                        },
                    )
                    AppButton(
                        text = stringResource(Res.string.profile_pro_plan_row, label, AppTheme.language.formatPriceCents(plan.priceCents)),
                        onClick = {
                            failed = false; busy = true
                            scope.launch {
                                val url = onCheckout(plan.id)
                                busy = false
                                if (url != null) uriHandler.openUri(url) else failed = true
                            }
                        },
                        modifier = Modifier.fillMaxWidth(),
                        loading = busy,
                        enabled = !busy,
                    )
                }
            }
        }
    }
}

@Composable
private fun Stat(value: Int, label: String, onClick: (() -> Unit)? = null) {
    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
        // Only the Saved stat leads anywhere yet; the others stay inert rather than pretending.
        modifier = if (onClick != null) Modifier.clickable(onClick = onClick) else Modifier,
    ) {
        Text(text = value.toString(), style = AppTheme.typography.headlineMd, color = AppTheme.colors.primary)
        Text(text = label, style = AppTheme.typography.bodySm, color = AppTheme.colors.onSurfaceVariant)
    }
}

/** Localized relationship label, or null when the (optional) status is unset — privacy by default. */
@Composable
private fun relationshipLabel(wire: String?): String? {
    val status = diana.soleil.design.iraniancanadienbazzar.core.model.RelationshipStatus.entries
        .firstOrNull { it.wire == wire } ?: return null
    return stringResource(
        when (status) {
            diana.soleil.design.iraniancanadienbazzar.core.model.RelationshipStatus.Single ->
                Res.string.profile_relationship_single
            diana.soleil.design.iraniancanadienbazzar.core.model.RelationshipStatus.InRelationship ->
                Res.string.profile_relationship_in_relationship
            diana.soleil.design.iraniancanadienbazzar.core.model.RelationshipStatus.Married ->
                Res.string.profile_relationship_married
        },
    )
}

/** "Farsi, English" from wire codes; null when none are set. */
@Composable
private fun languagesLabel(codes: List<String>): String? {
    if (codes.isEmpty()) return null
    // Resolve the labels up front — joinToString's lambda is not a composable context.
    val labels = mapOf(
        "en" to stringResource(Res.string.profile_lang_en),
        "fa" to stringResource(Res.string.profile_lang_fa),
        "fr" to stringResource(Res.string.profile_lang_fr),
    )
    return codes.joinToString(", ") { labels[it] ?: it }
}
